// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { headerStyles } from "@sc/Overrides/Pages/Header";
import { constants } from "@sc/XDL/constants";
import { color, companyLogoItem, layoutContainer, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

headerStyles.page = {
    fullWidth: [true, true, true, true, true, true],
    padding: 0,
    css: css`
        box-shadow: 0 1px 0 0 ${getColor("common.border")};
        z-index: ${getProp("theme.zIndex.header")};
        position: relative;
    `,
};

headerStyles.container = {
    css: css`
        background-color: ${getColor("common.background")};
        display: flex;
        padding: 12px 0 8px;
        align-items: center;

        ${({ isCheckoutPage }: any) => (isCheckoutPage ? "padding: 8px 0;" : "")}

        ${layoutContainer}

        ${xScreen("lte", "md")} {
            ${({ isAuthenticated }: any) =>
                isAuthenticated
                    ? `height: ${constants.header.tablet.size.authenticated}px;`
                    : `height: ${constants.header.tablet.size.unAuthenticated}px;`}
        }

        ${xScreen("lte", 767)} {
            flex-wrap: wrap;
            row-gap: 12px;

            ${({ isAuthenticated }: any) =>
                isAuthenticated
                    ? `height: ${constants.header.mobile.size.authenticated}px;`
                    : `height: ${constants.header.mobile.size.unAuthenticated}px;`}

            &&&& {
                padding-bottom: 12px;
            }
        }
    `,
};

headerStyles.headerWrapper = {
    css: css`
        &&&& {
            ${({ isAuthenticated }: any) =>
                !isAuthenticated &&
                css`
                    position: sticky;
                    top: 0;
                    z-index: ${getProp("theme.zIndex.header")};
                `}

            ${xScreen("lte", "md")} {
                position: sticky;
                top: 0;
                z-index: ${getProp("theme.zIndex.header")};
            }

            @media print {
                display: none;
            }
        }
    `,
};

headerStyles.printLogo = companyLogoItem;

headerStyles.mainNavigationWrapper = {
    css: css`
        padding-bottom: 8px;
    `,
};
headerStyles.signInCartlinks = {
    css: css`
        display: flex;
        align-items: center;
        gap: 36px;
        margin-left: auto;
        padding-right: 8px;
        ${xScreen("lte", "md")} {
            gap: 16px;
            padding-right: 0;
        }
    `,
};
headerStyles.secondaryNavWrapper = {
    css: css`
        background: ${color("common.ui9")};
    `,
};
headerStyles.headerLinkList = {
    css: css`
        width: auto;
        display: flex;
        align-items: center;
        margin-left: auto;
        & > div:last-child {
            display: flex;
            align-items: center;
        }
        ${xScreen("lte", 767)} {
            display: none;
        }
    `,
};
headerStyles.logo = {
    css: css`
        ${xScreen("lte", "md")} {
            margin-left: 16px;
        }
    `,
};
headerStyles.checkoutLogo = {
    css: css`
        .wrapper {
            display: flex;
            height: 40px;
            width: 218px;
        }
    `,
};
headerStyles.checkoutHeaderWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        &&& {
            padding-top: 8px;
            padding-bottom: 8px;
        }

        ${xScreen("lte", 767)} {
            flex-direction: column;
            row-gap: 12px;
            align-items: flex-start;
        }
    `,
};
headerStyles.checkoutHelpMsg = {
    css: css`
        font-size: 12px;
        line-height: 14px;
    `,
};

headerStyles.searchWrapper = {
    css: css`
        max-width: 832px;
        margin-left: 66px;
        flex-grow: 1;
        margin-right: 66px;
        ${xScreen("lte", "lg")} {
            max-width: 656px;
        }
        ${xScreen("lte", "md")} {
            margin-left: 43px;
            margin-right: 67px;
        }
        ${xScreen("lte", 767)} {
            margin: 0;
            width: 100%;
            order: 5;
            max-width: unset;
        }
    `,
};
